<template>
  <div class="font-opensans cat-page">

    <div class="cat-header">
      <div class="cat-header-title">
        <b-icon icon="bag-check" font-scale="1.1"></b-icon>
        <span>Nuevo Producto</span>
      </div>
      <b-button class="cat-header-back" @click="goBack()">
        <b-icon icon="arrow-left"></b-icon> Regresar
      </b-button>
    </div>

    <div class="cat-form-card">
      <b-form @submit.prevent="submitForm">
            <!-- Clave -->
            <b-form-group label="Clave:" label-for="clave" class="pt-2 pb-3">
              <b-form-input
                id="clave"
                v-model="producto.clave"
                :maxlength="20"
                required
                placeholder="Clave del producto"
                class="mt-1 shadow-sm"
              ></b-form-input>
            </b-form-group>
  
            <!-- Descripción -->
            <b-form-group label="Descripción:" label-for="descripcion" class="pb-3">
              <b-form-input
                id="descripcion"
                v-model="producto.descripcion"
                :maxlength="150"
                required
                placeholder="Descripción del producto"
                class="mt-1 shadow-sm"
              ></b-form-input>
            </b-form-group>
  
            
            <b-row>
              <!-- Tipo de Producto -->
              <b-col class="cols-6" xs="12" s="6" md="6" lg="4" xl="4">
                <b-form-group label="Tipo de Producto:" label-for="tipoProducto" class="pb-3">
                  <b-form-select
                    id="tipoProducto"
                    v-model="producto.tipo_producto_id"
                    :options="tipoProductoOptions"
                    required
                    class="shadow-sm border rounded custom-border px-2 py-1 mt-1"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <!-- Estatus -->
               <b-col class="cols-6" xs="12" s="6" md="6" lg="8" xl="8">
                <b-form-group label="Estatus:" label-for="estatus" class="pb-3">
                  <b-form-select
                    id="estatus"
                    v-model="producto.estatus"
                    :options="estatusOptions"
                    required
                    :disabled="nuevo"
                    class="shadow-sm border rounded custom-border px-2 py-1 mt-1"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-row>
                <b-col md="4">
                  <label for="">Creado: {{producto.fecha_hora_creacion}}</label>
                </b-col>
                <b-col md="4">
                  <label for="">Modificado:{{producto.fecha_hora_modif}}</label>
                </b-col>
                
                
              </b-row>
    
              
              
            </b-row>
            
            <b-button class="cat-back-btn me-2" @click="goBack()"><b-icon icon="arrow-left"></b-icon> Regresar</b-button>
            <b-button v-if="!cargando" type="submit" class="cat-save-btn"><b-icon icon="check2"></b-icon> Guardar</b-button>
            <b-spinner v-else class="text-center" variant="warning"></b-spinner>
          </b-form>
      <Modals ref="mod"></Modals>
    </div>
  </div>
  </template>
  
  <script>
  import Modals from '@/components/Modals.vue'
  import {mapState,mapActions} from 'vuex'
  import * as utils from "@/shared/util"
  export default {
    data() {
      return {
        nuevo:true,
        cargando: false,
        texto: "Producto",
        producto: {
          clave: '',
          descripcion: '',
          tipo_producto_id: null,
          estatus: 'A',
        },
        tipoProductoOptions: [
          { value: null, text: 'Seleccione el tipo de producto' },
          { value: 1, text: 'Tipo 1' },
          { value: 2, text: 'Tipo 2' },
          { value: 3, text: 'Tipo 3' },
        ],
        estatusOptions: [
          { value: 'A', text: 'ACTIVO' },
          { value: 'B', text: 'BAJA' },
        ],
      };
    },
    components: {
        Modals,
        // Operadores,
    },
    computed: {
      ...mapState(['operador','modal','menu']),
      // name() {
      //   return this.data 
      // }
    },
    created() {
      
      let f=Date();
      this.producto.fecha_hora_creacion= utils.getDateTime(f)
      this.producto.fecha_modif=utils.getDateTime(f)
     
      //cargamos los catalogos que involucran a los productos productos
      this.$store.dispatch("getCatalogosProductos").then((resp)=>{
       //console.info("el catalogo de productos:"+ JSON.stringify(resp) )
        if (resp.estatus==1){
            this.tipoProductoOptions=resp.tipos_productos
        }
        
      }).then((error)=>{
        console.error(error)
      })

      if(this.$route.params.producto_id != undefined){
        this.producto=this.$route.params
        this.nuevo=false
      }
     //console.info("Los params enviados son:"+ JSON.stringify(this.$route.params) )
      // this.form.estatus=1
     //console.log("Es nuevo :" + this.nuevo)
    },
    methods: {
      ...mapActions(['actupdateMenu','actupdateModal']),
      showmodal(tittle,message){
          this.modal.tittle = tittle
          this.modal.message = message
          this.modal.type = 0
          this.actupdateModal(this.modal)
         //console.log("ahora contiene:  " + JSON.stringify(this.modal))
          this.$refs.mod.showmodal()
      },
      submitForm() {
        this.cargando=true
        // Aquí puedes manejar la lógica para enviar el formulario
       //console.log("el producto:" + JSON.stringify(this.producto));
        if(this.nuevo){
          this.$store.dispatch("createProducto",this.producto).then((res)=>{
           //console.log("dispatch createProducto trajo: "+JSON.stringify(res))
            if(res.estatus==1){
              this.cargando=false
              this.goBack()
            }else{
              this.cargando=false
              this.showmodal(this.texto, res.message)
            }
          }).catch((error)=>{
            this.cargando=false
            this.showmodal(this.texto, error)
          })
        }else{
          this.$store.dispatch("updateProducto",this.producto).then((res)=>{
           //console.log("dispatch updateProducto trajo: "+JSON.stringify(res))
            if(res.estatus==1){
              this.cargando=false
              this.goBack()
            }else{
              this.cargando=false
              this.showmodal(this.texto, res.message)
            }
          }).catch((error)=>{
            this.cargando=false
            this.showmodal(this.texto, error)
          })
        }
      },
      goBack(){
       
        this.$router.go(-1)
      },
    },
  };
  </script>
  
  <style scoped>
  @import "@/assets/css/app.css";

  .cat-page { min-height: 100vh; background: #f0f4f8; padding-bottom: 2rem; }
  .cat-header {
    display: flex; align-items: center; justify-content: space-between;
    background: linear-gradient(90deg, #0d2b5e 0%, #1a4d8f 60%, #316ea0 100%);
    padding: 0.75rem 1.5rem; color: #fff;
  }
  .cat-header-title { display: flex; align-items: center; gap: 0.5rem; font-size: 1.1rem; font-weight: 600; }
  .cat-header-back {
    background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.4);
    color: #fff; font-size: 0.85rem; border-radius: 6px; padding: 0.3rem 0.9rem;
  }
  .cat-header-back:hover { background: rgba(255,255,255,0.28); }
  .cat-form-card {
    background: #fff; border-radius: 0 0 12px 12px;
    box-shadow: 0 2px 12px rgba(13,43,94,0.08); padding: 1.5rem; margin: 0 1rem 1rem;
  }
  .cat-save-btn {
    background: linear-gradient(90deg, #0d2b5e, #1a4d8f); border: none;
    color: #fff; border-radius: 6px; padding: 0.4rem 1.2rem; font-weight: 600;
  }
  .cat-save-btn:hover { background: linear-gradient(90deg, #1a4d8f, #316ea0); }
  .cat-back-btn {
    background: transparent; border: 1px solid #6c757d;
    color: #6c757d; border-radius: 6px; padding: 0.4rem 1rem; font-weight: 600;
  }
  .cat-back-btn:hover { background: #6c757d; color: #fff; }
  @media (max-width: 576px) {
    .cat-header { padding: 0.6rem 1rem; }
    .cat-header-title { font-size: 1rem; }
    .cat-form-card { padding: 1rem 0.75rem; margin: 0 0.5rem 1rem; }
    .cat-save-btn, .cat-back-btn { width: 100%; margin-bottom: 0.5rem; }
  }
  </style>
  